import React from "react";
import { StyleSheet, View } from "react-native";
import CustomText from "@components/CustomText";

const ProgressBar = ({ title = "", completed = 0, total = 0 }) => {
  const progress = (completed * 100) / total || 0;
  return (
    <View style={styles.progressBarContainer}>
      <View style={styles.pbHeader}>
        <CustomText
          variant="body_text_4"
          style={{ color: "rgba(0, 0, 0, 0.56)" }}
        >
          {title}
        </CustomText>
        <View style={styles.pbUser}>
          <CustomText
            variant="title_16"
            style={{
              color: completed === total ? "#00AB59" : "rgba(0, 0, 0, 0.56)",
            }}
          >
            {completed}
          </CustomText>
          <CustomText
            variant="title_16"
            style={{
              color: completed === total ? "#00AB59" : "rgba(0, 0, 0, 0.56)",
            }}
          >
            {`/${total}`}
          </CustomText>
        </View>
      </View>
      <View>
        <View style={styles.progressBar} />
        <View
          style={[
            styles.progressBar,
            {
              backgroundColor: "rgba(0, 171, 89, 1)",
              marginTop: -8,
              width: `${progress}%`,
            },
          ]}
        />
      </View>
    </View>
  );
};

export default ProgressBar;

const styles = StyleSheet.create({
  progressBarContainer: {
    paddingHorizontal: 16,
    paddingBottom: 10,
  },
  pbHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  progressBar: {
    height: 8,
    backgroundColor: "rgba(0, 171, 89, 0.1)",
    borderRadius: 8,
  },
  pbUser: {
    flexDirection: "row",
  },
});
